import styled from 'styled-components';

export const StyledTextfieldWrapper = styled('div')`
  input {
    height: 70px;
    color: ${({ theme }) => theme.color.white};
    border-radius: 0;

    /* Chrome, Safari, Edge, Opera */
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    &[type='number'] {
      -moz-appearance: textfield;
    }

    &:focus {
      background-color: ${({ theme }) => theme.color.brand01RGBA(0.1)};
    }

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      -webkit-text-fill-color: ${({ theme }) => theme.color.white};
    }
  }
  span {
    height: 70px;
    top: 15px;
    color: ${({ theme }) => theme.color.white};
  }
`;
